// extracted by mini-css-extract-plugin
export var scrollArea = "_or-0";